import { FC, HTMLAttributes } from 'react';

import { Divider, Layout } from 'antd';
import cn from 'classnames';

import { Navigation } from 'features/Navigation';
import { SubNav } from 'features/SubNav';
import { useDisableBodyScroll, useMedia } from 'shared/hooks';
import { Logo } from 'shared/ui';
import { useSidebarSlice } from 'widgets/Sidebar/hooks/useSidebarSlice';

import styles from './Sidebar.module.scss';

const { Sider } = Layout;

interface ISidebarProps extends HTMLAttributes<HTMLDivElement> {}

export const Sidebar: FC<ISidebarProps> = ({ className, ...props }) => {
	const { collapsed, opened } = useSidebarSlice();
	const isXl = useMedia('xl');
	useDisableBodyScroll(isXl && opened);

	return (
		<Sider
			{...props}
			className={cn(className, styles.sidebar, { [styles.opened]: opened })}
			collapsed={collapsed && !isXl}
			width={isXl ? '100%' : 250}
			theme="light">
			{!isXl && <Logo collapsed={collapsed && !isXl} />}

			<div className={styles.nav}>
				<Navigation className={styles.menu} />
				<div className={styles.divider}>
					<Divider style={{ margin: 0 }} />
				</div>
				<SubNav className={cn(styles.menu, styles.subnav)} />
			</div>
		</Sider>
	);
};
